/* Custom placeholder for the Sodo Search popup. The default text is a Ghost
   core translation rendered inside the search iframe, so it can't be changed
   via theme locales — we rewrite it whenever the popup (re)renders. */
(function () {
    const placeholder = 'Zoek op filmtitel, auteur of eender welke term';
    const watchedDocs = new WeakSet();

    function patch(doc) {
        const input = doc.querySelector('input');
        if (input && input.placeholder !== placeholder) {
            input.placeholder = placeholder;
        }
    }

    function watch(iframe) {
        const doc = iframe.contentDocument;
        if (!doc || watchedDocs.has(doc)) return;
        watchedDocs.add(doc);
        patch(doc);
        new MutationObserver(function () {
            patch(doc);
        }).observe(doc, {childList: true, subtree: true});
    }

    /* The iframe is only injected once search is first opened, and its
       document can be replaced, so keep watching for both. */
    new MutationObserver(function () {
        const iframe = document.querySelector('#sodo-search-root iframe');
        if (iframe) {
            watch(iframe);
            iframe.addEventListener('load', function () {
                watch(iframe);
            });
        }
    }).observe(document.documentElement, {childList: true, subtree: true});
})();
